<template>
  <component
    :is="componentType"
    :type="!link ? type : false"
    :to="redirectionLink"
    class="button button-primary"
    :class="{ 'disabled': disabled }"
    data-testid="subscribeSubmit"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot>
      Button
    </slot>
  </component>
</template>
<script>
import BaseButton from './BaseButton'

export default {
  name: 'ButtonPrimary',
  mixins: [ BaseButton ]
}
</script>
